import { Checkbox } from "@/components/ui/checkbox";

interface ScenarioAutoShareSettingsProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function ScenarioAutoShareSettings({
  checked,
  onChange,
}: ScenarioAutoShareSettingsProps) {
  return (
    <div className="mt-4">
      <div className="font-semibold">Other Settings</div>
      <div className="mt-2 flex items-start gap-2 p-3 border border-border rounded-md">
        <Checkbox
          id="auto-share-sessions"
          checked={checked}
          onCheckedChange={(checked) => onChange(!!checked)}
          className="mt-0.5"
        />
        <label
          htmlFor="auto-share-sessions"
          className="text-sm text-gray-700 cursor-pointer select-none"
        >
          <div className="font-medium">
            Enable monitoring of sessions done by all users
          </div>
          <div className="text-xs text-gray-500 mt-1">
            When enabled, all practice sessions will be automatically visible to
            scenario owners, editors, and monitors for training purposes.
          </div>
        </label>
      </div>
    </div>
  );
}
